import { SubtitleTypography } from "@/components/common/Typographies";
import { ArrowRightAlt, Moving } from "@mui/icons-material";
import { Stack, SvgIconProps } from "@mui/material";
import { ReactNode } from "react";
import { ImprovementComparisonType } from "../commons/sleep_summaries";

interface SectionLayoutProps {
  title: string;
  titleSideContent?: ReactNode;
  children?: ReactNode;
  border_color?: string;
}
/**
 * ワークシートのセクション共通のレイアウト
 * @param props {@link SectionLayoutProps}
 * @returns ワークシートのセクション共通のレイアウト
 */
export function SectionLayout({
  title,
  titleSideContent,
  children,
  border_color = "primary.main",
}: SectionLayoutProps) {
  return (
    <Stack sx={{ gap: 6 }}>
      <Stack direction="row" sx={{ gap: 2 }}>
        <SubtitleTypography borderColor={border_color}>
          {title}
        </SubtitleTypography>
        {titleSideContent}
      </Stack>
      <Stack>{children}</Stack>
    </Stack>
  );
}

/**
 * 右上がりアイコン
 * @param props {@link SvgIconProps}
 * @returns 右上がりアイコン
 */
export function MovingUp({ sx, ...props }: SvgIconProps) {
  return <Moving sx={{ color: "#0056A0", ...sx }} {...props} />;
}
/**
 * 右下がりアイコン
 *
 * @param props {@link SvgIconProps}
 * @returns 右下がりアイコン
 */
export function MovingDown({ sx, ...props }: SvgIconProps) {
  return (
    <Moving
      sx={{ transform: "rotateX(180deg)", color: "#FF3A30", ...sx }}
      {...props}
    />
  );
}

/**
 * 横這いアイコン
 * @param props {@Link SvgIconProps}
 * @returns 横這いアイコン
 */
export function MovingSideway({ sx, ...props }: SvgIconProps) {
  return <ArrowRightAlt sx={{ color: "#A3A3A3" }} {...props} />;
}

type MoveImprovementProps = SvgIconProps & {
  improvement: ImprovementComparisonType | null | undefined;
};

/**
 * {@link MoveImprovementProps#improvement} からアイコンを判定します。
 *
 * @param props {@link MoveImprovementProps}
 * @returns 判定後アイコン
 */
export function MoveImprovement({
  improvement,
  ...props
}: MoveImprovementProps) {
  if (improvement == null) return <></>;
  const icon: ReactNode = {
    greater_than: <MovingUp {...props} />,
    less_than: <MovingDown {...props} />,
    equal: <MovingSideway {...props} />,
  }[improvement];
  return icon;
}
